const LOCAL_PART_PATTERN =
  /^[A-Za-z0-9!#$%&'*+\-/=?^_`{|}~¡-￿]+(\.[A-Za-z0-9!#$%&'*+\-/=?^_`{|}~¡-￿]+)*$/;
const DOMAIN_LABEL_PATTERN =
  /^[A-Za-z0-9¡-￿]([A-Za-z0-9¡-￿-]*[A-Za-z0-9¡-￿])?$/;
const TOP_LEVEL_DOMAIN_PATTERN = /^([A-Za-z¡-￿]{2,}|xn[A-Za-z0-9-]{2,})$/;
const MAX_LOCAL_PART_LENGTH = 64;
const MAX_DOMAIN_LENGTH = 254;
const MAX_DOMAIN_LABEL_LENGTH = 63;

// Same rules as isValidEmailFormat in frontend/src/shared/lib/utils/email.ts, which mirrors the
// defaults of the server's `isEmail`: an address the fill accepts must not be refused on save.
export function isValidEmailFormat(emailValue: string): boolean {
  const separatorIndex = emailValue.lastIndexOf('@');

  if (separatorIndex < 1) return false;

  const localPart = emailValue.slice(0, separatorIndex);
  const domain = emailValue.slice(separatorIndex + 1);

  if (localPart.length > MAX_LOCAL_PART_LENGTH || domain.length > MAX_DOMAIN_LENGTH) return false;
  if (!LOCAL_PART_PATTERN.test(localPart)) return false;

  const labels = domain.split('.');

  if (labels.length < 2) return false;
  if (!TOP_LEVEL_DOMAIN_PATTERN.test(labels[labels.length - 1])) return false;

  return labels.every(
    (label) => label.length <= MAX_DOMAIN_LABEL_LENGTH && DOMAIN_LABEL_PATTERN.test(label),
  );
}
